import React, { useEffect, useMemo, useState } from 'react'

import { Col, Row, Modal } from 'react-bootstrap'
import { Button, Paragraph, ListTags, FilterByCategory } from 'src/components'
import { faPlus, faSave, faSort } from '@fortawesome/free-solid-svg-icons'
import { POSSortCategories } from 'src/content/Restaurant/POSCategories/POSSortCategories'
import { assignParentIdToCategories } from 'src/content/Restaurant/POSCategories/POSCategoriesFunctions'
import { useSelector } from 'react-redux'
import { selectAllCategorizations } from 'src/selectors/categorizations.selector'
import { haveAnyValue } from 'src/utils/utilitiesV2'

interface IPOSAddCategoriesProps {
  show: boolean
  categories: ICategory[]
}

interface IPOSCategoriesProps {
  categories: ICategory[]
  onChange: (categories: ICategory[]) => void
}

export const POSCategories = ({ categories = [], onChange }: IPOSCategoriesProps) => {
  const categorization = useSelector(selectAllCategorizations)

  const [showAddCategories, setShowAddCategories] = useState<IPOSAddCategoriesProps>({
    show: false,
    categories: [],
  })
  const [showSortCategories, setShowSortCategories] = useState<boolean>(false)

  const [posCategories, setPosCategories] = useState<ICategorization[]>([])

  const categoriesWithParent = useMemo(() => {
    return assignParentIdToCategories(categories, posCategories)
  }, [categories, posCategories])

  useEffect(() => {
    const posCategories: ICategorization[] =
      categorization?.children?.find(c => c.id === -2)?.children ?? []
    setPosCategories(posCategories)
  }, [categorization])

  const onAddedCategories = () => {
    onUpdateCategories(showAddCategories.categories)
    setShowAddCategories({ ...showAddCategories, show: false })
  }

  const onSortedCategories = (sorted: ICategory[]) => {
    onUpdateCategories(sorted)
    setShowSortCategories(false)
  }

  const onUpdateCategories = (categoriesUpdated: ICategory[]) => {
    onChange(categoriesUpdated)
  }

  return (
    <div>
      <Row>
        <Col xl={3} lg={3} md={3} sm={12} xs={12}>
          <label className={'ftf-form-label left mt-3'}>Categorías</label>
        </Col>
        <Col xl={9} lg={9} md={9} sm={12} xs={12}>
          <Row className={'container-buttons'}>
            <Button
              icon={faPlus}
              color={'accent'}
              onClick={() => setShowAddCategories({ categories, show: true })}>
              Agregar
            </Button>
            <Button
              icon={faSort}
              color={'accent'}
              onClick={() => setShowSortCategories(true)}>
              Ordenar
            </Button>
          </Row>
        </Col>

        {categories.length === 0 ? (
          <Paragraph>
            Este punto de venta no tiene categorías específicas asignadas. Por lo tanto,
            se aplicarán automáticamente todas las categorías disponibles del tipo
            &quot;Punto de venta&quot;.
          </Paragraph>
        ) : (
          // @ts-ignore
          <ListTags
            tags={categoriesWithParent.map(c => ({
              value: c.id,
              label: c.name,
              small: haveAnyValue(c.parentId),
            }))}
          />
        )}
      </Row>

      <Modal
        show={showAddCategories.show}
        centered
        onHide={() => setShowAddCategories({ ...showAddCategories, show: false })}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar categorías</Modal.Title>
        </Modal.Header>
        <Modal.Body className={'custom-modal-body'}>
          <Paragraph>
            Seleccione las categorías que desea agregar a este punto de venta. Las
            categorías le ayudan a organizar sus productos y facilitan la búsqueda durante
            la venta.
          </Paragraph>

          {/* @ts-ignore */}
          <FilterByCategory
            initial={showAddCategories.show}
            list={showAddCategories.categories}
            get={r => setShowAddCategories({ ...showAddCategories, categories: r })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Row className={'container-buttons'}>
            <Button icon={faSave} onClick={onAddedCategories}>
              Guardar
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>

      <POSSortCategories
        show={showSortCategories}
        categories={categories}
        onChange={categories => onSortedCategories(categories)}
      />
    </div>
  )
}
